import { render, staticRenderFns } from "./DatatableOperations.vue?vue&type=template&id=b6369634&"
import script from "./DatatableOperations.vue?vue&type=script&lang=js&"
export * from "./DatatableOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports